import React, { useEffect } from 'react';
import {
  DRIVER_ATTRIBUTE,
  DRIVER_ATTRIBUTE_CODE_TYPE,
} from '@common/constant/masterData';
import driverApi from '@services/apis/driver';
import { Checkbox, Form, Input, Space } from 'antd';
import PropTypes from 'prop-types';

function FieldDriverCode({ name, ...props }) {
  const {
    driverId,
    initialDriverAttributeCodeTypes,
    initialCompanyCode,
    initialDriverCode,
    setInitialValues,
  } = props;

  const attributeRules = [
    () => ({
      async validator({ field }, value) {
        if (value) {
          try {
            const response = await driverApi.validateDriverAttribute({
              driverId,
              attribute:
                field === 'driverCode'
                  ? DRIVER_ATTRIBUTE.DRIVER_CODE
                  : DRIVER_ATTRIBUTE.COMPANY_CODE,
              value,
            });

            if (response.status === true) {
              return Promise.resolve();
            }

            return Promise.reject(
              new Error(response.message || '予期せぬエラーが発生しました。'),
            );
          } catch (err) {
            return Promise.reject(new Error('予期せぬエラーが発生しました。'));
          }
        }

        return Promise.resolve();
      },
    }),
  ];

  useEffect(() => {
    setInitialValues({
      companyCodeCheckbox: initialDriverAttributeCodeTypes.includes(
        DRIVER_ATTRIBUTE_CODE_TYPE.COMPANY_CODE,
      ),
      driverCodeCheckbox: initialDriverAttributeCodeTypes.includes(
        DRIVER_ATTRIBUTE_CODE_TYPE.DRIVER_CODE,
      ),
    });
  }, [initialDriverAttributeCodeTypes]);

  return (
    <Space direction="vertical" size="middle">
      <Space align="center">
        <Form.Item
          name="companyCodeCheckbox"
          valuePropName="checked"
          style={{ width: 100 }}
        >
          <Checkbox>社番</Checkbox>
        </Form.Item>
        <Form.Item
          name="companyCode"
          colon="false"
          layout="inline"
          initialValue={initialCompanyCode}
          rules={attributeRules}
          style={{ width: 200 }}
        >
          <Input />
        </Form.Item>
      </Space>
      <Space align="center">
        <Form.Item
          name="driverCodeCheckbox"
          valuePropName="checked"
          style={{ width: 100 }}
        >
          <Checkbox>乗組員ID</Checkbox>
        </Form.Item>
        <Form.Item
          name="driverCode"
          colon="false"
          layout="inline"
          initialValue={initialDriverCode}
          rules={attributeRules}
          style={{ width: 200 }}
        >
          <Input />
        </Form.Item>
      </Space>
    </Space>
  );
}

export default FieldDriverCode;

FieldDriverCode.propTypes = {
  driverId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  initialDriverAttributeCodeTypes: PropTypes.arrayOf(PropTypes.string),
  initialCompanyCode: PropTypes.string,
  initialDriverCode: PropTypes.string,
  setInitialValues: PropTypes.func,
};
